import ReceiptTextWithBadgeCheckSvg from '@assets/images/svg/receipt-text-with-badge-check.svg';
import React from 'react';
import { View } from 'react-native';

export interface ReceiptTextWithBadgeCheckIconProps {
    size?: number;
    color?: string;
}

export function ReceiptTextWithBadgeCheckIcon({ size = 80, color = '#B3B3B3' }: ReceiptTextWithBadgeCheckIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ReceiptTextWithBadgeCheckSvg width={size} height={size} color={color} />
        </View>
    );
}

export default ReceiptTextWithBadgeCheckIcon;

